// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invIntakeSessionId } from './InvIntakeSession';
import { invIntakeDraftStatusEnum } from './InvIntakeDraftStatusEnum';
import { invProductId } from './InvProduct';
import { invItemId } from './InvItem';
import { operatorId } from './Operator';
import { z } from 'zod';
export const invIntakeDraftId = (z.number());
export const invIntakeDraft = z.object({
    id: invIntakeDraftId,
    session_id: invIntakeSessionId,
    status: invIntakeDraftStatusEnum,
    extraction: z.unknown().nullable(),
    corrections: z.unknown().nullable(),
    error_message: z.string().nullable(),
    product_id: invProductId.nullable(),
    item_id: invItemId.nullable(),
    committed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    labeled_at: z.date().nullable(),
    review_state: z.unknown().nullable(),
    extraction_seq: z.number(),
    is_capture_target: z.boolean(),
});
export const invIntakeDraftInitializer = z.object({
    id: invIntakeDraftId.optional(),
    session_id: invIntakeSessionId,
    status: invIntakeDraftStatusEnum.optional(),
    extraction: z.unknown().optional().nullable(),
    corrections: z.unknown().optional().nullable(),
    error_message: z.string().optional().nullable(),
    product_id: invProductId.optional().nullable(),
    item_id: invItemId.optional().nullable(),
    committed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    labeled_at: z.date().optional().nullable(),
    review_state: z.unknown().optional().nullable(),
    extraction_seq: z.number().optional(),
    is_capture_target: z.boolean().optional(),
});
export const invIntakeDraftMutator = z.object({
    id: invIntakeDraftId.optional(),
    session_id: invIntakeSessionId.optional(),
    status: invIntakeDraftStatusEnum.optional(),
    extraction: z.unknown().optional().nullable(),
    corrections: z.unknown().optional().nullable(),
    error_message: z.string().optional().nullable(),
    product_id: invProductId.optional().nullable(),
    item_id: invItemId.optional().nullable(),
    committed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    labeled_at: z.date().optional().nullable(),
    review_state: z.unknown().optional().nullable(),
    extraction_seq: z.number().optional(),
    is_capture_target: z.boolean().optional(),
});
//# sourceMappingURL=InvIntakeDraft.js.map